/**
 * 账户
 */

import { HTTP_ALB } from '../axios'

//  账户列表
export const getadvlist = params => {
  return HTTP_ALB.get('/foundation/adv/list', params)
}
//  获取基础信息 场次大屏
export const get_live_baseinfo = params => {
  return HTTP_ALB.get('/live/sph/live_baseinfo', params)
}
//  获取核心数据 场次大屏
export const get_sph_live_core_data = params => {
  return HTTP_ALB.get('/live/sph/live_core_data', params)
}
//  人员绑定直播间接口-列表
export const getLiveList= params => {
  return HTTP_ALB.get('/staff/live/list', params)
}
//  人员绑定直播间接口-删除
export const getLiveDel= params => {
  return HTTP_ALB.get('/staff/live/del', params)
}
//  人员绑定直播间接口-新增
export const getLiveAdd= params => {
  return HTTP_ALB.post('/staff/live/add', params)
}
//  人员绑定直播间接口批量
export const getLiveBatch_bind= params => {
  return HTTP_ALB.post('/staff/live/batch_bind', params)
}

//  主播管理--关闭/开启账号新增
export const statusEdit= params => {
  return HTTP_ALB.post('/staff/status/edit', params)
}

// 添加账户
export const addadv = params => {
  return HTTP_ALB.post('/foundation/adv/add', params)
}
// 编辑账户
export const editadv = params => {
  return HTTP_ALB.post('/foundation/adv/edit', params)
}

// 获取账户授权链接
export const getisauth = params => {
  return HTTP_ALB.post('/foundation/adv/isauth', params)
}
// 获取账户授权链接
export const getauth = params => {
  return HTTP_ALB.post('/foundation/adv/auth', params)
}

// 账户信息接口
export const getsaaslist = params => {
  return HTTP_ALB.get('/foundation/adv/saaslist', params)
}

// 获取当前直播间已关联过的账户
export const getaweme = params => {
  return HTTP_ALB.get('/foundation/adv/aweme', params)
}

//行业索引

export const getindustrcolumn = params => {
  return HTTP_ALB.get('/foundation/industry/column', params)
}

//直播间排班接口
export const scheduleData = params => {
  return HTTP_ALB.post('/anchor/schedule/calendar', params)
}

//添加排班
export const setClasses = params => {
  return HTTP_ALB.post('/anchor/schedule/add', params)
}

//删除直播间排班
export const delClassesData = params => {
  return HTTP_ALB.post('/anchor/schedule/del', params)
}

//编辑直播间排班
export const emitClassesData = params => {
  return HTTP_ALB.post('/anchor/schedule/edit', params)
}

//排班详情
export const classesDetails = params => {
  return HTTP_ALB.get('/anchor/schedule/detail', params)
}

//导出数据
export const deriveClasses = params => {
  return HTTP_ALB.post('/anchor/schedule/export', params)
}

//复制昨日排班
export const getHistory = params => {
  return HTTP_ALB.post('/anchor/schedule/copy', params)
}

//排班日历
export const getCalendar = params => {
  return HTTP_ALB.post('/schedule/calendar/calendar', params)
}

//排班日历详情
export const calendarDetails = params => {
  return HTTP_ALB.post('/schedule/calendar/hour', params)
}


